import type { ViewportToolsetPlugin } from "@/viewport-tools/plugin-types";
import type { MeasurementToolsetRailController } from "@/viewport-tools/rail/types";
import { getMeasurementToolDefinitions, MEASUREMENT_TOOLSET } from "./registry";
import { MEASUREMENT_TOOLSET_RAIL_PLUGIN } from "./rail-plugin";

export const MEASUREMENT_VIEWPORT_TOOLSET_PLUGIN: ViewportToolsetPlugin<MeasurementToolsetRailController> =
  {
  id: MEASUREMENT_TOOLSET.id,
  toolset: MEASUREMENT_TOOLSET,
  getTools: () => getMeasurementToolDefinitions(),
  rail: MEASUREMENT_TOOLSET_RAIL_PLUGIN,
  };
